import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_56m6aez3hh: FaireBrandEntity = {
  token: "b_56m6aez3hh",
  type: "brand",
  name: "Pearhead",
  avatarUrl: "https://cdn.faire.com/fastly/e25a0ede6d671bb32843a6c2e6e12b713266cb13032ffee64d2787f09cd3dd19.png",
  bannerUrl: "https://cdn.faire.com/fastly/e5c132cb46b826b97f12f4cc9b35da41b495210b29e235e152169b5286acdadf.png",
  logoUrl: "https://cdn.faire.com/fastly/e25a0ede6d671bb32843a6c2e6e12b713266cb13032ffee64d2787f09cd3dd19.png",
  heroImageUrl: "https://cdn.faire.com/fastly/e5c132cb46b826b97f12f4cc9b35da41b495210b29e235e152169b5286acdadf.png",
  location: "Brooklyn, NY, USA",
  minimumOrderDollars: 75,
  rating: 4.8,
  reviewCount: 716,
  isTopShop: true,
  isInsider: true,
  description: "At Pearhead, we aim to create genuine, quality products to celebrate your special moments in life. \n \nWe are a family of designers, marketers, and trendsetters bringing products to life that will bring a smile to your face.  From concept and design to production and customer service, the Pearhead team works together seamlessly every step of the way.  \n \nWhether your baby is celebrating their first year of life, you are announcing your engagement, or your pup is celebrating his first holiday season, Pearhead is here to help share your moments in style.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:02.435Z",
    importedBy: "entity-db-cli"
  }
};
